export default "__VITE_ASSET__8oxcAwgZ__"